// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT DIRECTLY.

export enum QuestionType {
    SCALE,
    TYPE,
    SLIDER,
    SELECTOR,
    TEXT_INPUT

}
export default QuestionType
